"use client"

import { ErrorMessage } from "@/app/error"
import { Card } from "@rarible_int/anaconda_ui_components"
import { Suspense } from "react"
import { ErrorBoundary } from "react-error-boundary"
import { DropActivityTable, DropActivityTableSkeleton } from "./activity-table"

export function DropActivityView() {
  return (
    <DropActivityLayout>
      <ErrorBoundary
        fallback={
          <div className="flex h-full flex-col items-center justify-center">
            <ErrorMessage />
          </div>
        }
      >
        <Suspense fallback={<DropActivityTableSkeleton />}>
          <DropActivityTable />
        </Suspense>
      </ErrorBoundary>
    </DropActivityLayout>
  )
}

export function DropActivityLayout({
  children,
}: { children: React.ReactNode }) {
  return (
    <Card
      className="min-h-[300px] flex-1 overflow-hidden px-2 sm:min-h-[unset]"
      data-testid="drop-activity-table"
    >
      {children}
    </Card>
  )
}
